export const Telegram = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 256 256"
    {...props}
  >
    <path
      fill="#fff"
      strokeMiterlimit={10}
      d="M20.303 2.984a2.437 2.437 0 0 0-.787.188c-.216.085-.988.41-2.22.926l-4.599 1.931-9.385 3.95c-.068.028-.347.114-.656.35-.309.235-.652.747-.652 1.308 0 .452.226.912.498 1.175.272.264.548.387.78.479l3.667 1.465c.318.952 1.064 3.194 1.239 3.746h-.002c.142.45.28.742.472.986.096.122.211.233.352.32.054.034.114.06.174.085l.025.007-.023-.005c.017.007.033.017.05.023.03.01.05.01.088.018.137.042.274.07.4.07.544 0 .878-.295.878-.295l.021-.016 2.348-1.986 2.875 2.658c.051.073.462.631 1.416.631.568 0 1.019-.28 1.306-.574.288-.295.467-.597.547-1.006v-.006c.056-.29 2.817-14.146 2.817-14.146l-.006.023c.086-.382.11-.752.01-1.129a1.62 1.62 0 0 0-.704-.937 1.65 1.65 0 0 0-.93-.239zm-.395 2.19c-.108.544-2.565 12.886-2.724 13.705l-2.856-2.639a2.012 2.012 0 0 0-2.648-.058l-1.457 1.232.777-3.039s5.363-5.428 5.686-5.744c.26-.253.314-.342.314-.43 0-.117-.06-.201-.2-.201-.124 0-.294.12-.384.176-1.148.716-6.066 3.518-8.447 4.873-.09-.054-.178-.11-.276-.149l-3.162-1.265a44504.747 44504.747 0 0 1 13.54-5.694c1.037-.435 1.579-.66 1.837-.767zm-2.756 13.85h.002l-.002.007c.002-.008 0-.001 0-.008z"
      fontFamily="none"
      fontSize="none"
      fontWeight="none"
      style={{
        mixBlendMode: "normal",
      }}
      textAnchor="none"
      transform="scale(10.66667)"
    />
  </svg>
)
export const Facebook = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 256 256"
    {...props}
  >
    <path
      fill="#fff"
      strokeMiterlimit={10}
      d="M12 27V15H8v-4h4V8.852C12 4.785 13.981 3 17.361 3c1.619 0 2.475.12 2.88.175V7h-2.305C16.501 7 16 7.757 16 9.291V11h4.205l-.571 4H16v12z"
      fontFamily="none"
      fontSize="none"
      fontWeight="none"
      style={{
        mixBlendMode: "normal",
      }}
      textAnchor="none"
      transform="scale(8.53333)"
    />
  </svg>
)